import React, { useEffect, useState } from "react";
import Link from "next/link";

import { BaseApiService } from "@/utils/BaseApiService";
import { useRouter } from "next/router";
import StorageParams from "@/constants/StorageParams";

const PricingThree = ({ title, tag, col, position }) => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false); // State for loading indicator
  const [loggedIn, setLoggenIn] = useState(false);
  const router = useRouter();
  const [subscriptionPlan, setSubscriptionPlan] = useState({});

  const [purchaseType, setPurchaseType] = useState("oneOff");
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [groupOptions, setGroupOptions] = useState([]);

  const [isDialogOpen, setDialogOpen] = useState(false);
  const handleDialogOpen = () => setDialogOpen(true);
  const handleDialogClose = () => setDialogOpen(false);


  const fetchSubscriptionPlans = async () => {
    let searchParameters = {
      searchTerm: "",
      offset: 0,
      limit: 0
    };

    try {
      const response = await new BaseApiService("/payments/subscription-plans").getRequestWithJsonResponse(
        searchParameters
      );
      console.log("Subscription Response:", response);
      if (response && response.records) {
        setPlans(response.records);
      } else {
        console.error("Unexpected response structure:", response);
      }
    } catch (error) {
      console.error("fetchSubscriptionPlans:fetchDataFromServer>>>>", error);
    }
  };

  const paySubscription = async () => {
    // Redirect to payment or handle continue logic
    try {
      const subType =
        purchaseType === "bulk" ? "BULK_SUBSCRIPTION_PAYMENT" : "SUBSCRIPTION_PAYMENT";
      const requestBody =
        purchaseType === "bulk"
          ? { organisationGroupId: selectedGroupId }
          : {};

      const response = await new BaseApiService(
        `/payments/pay/${subType}/${subscriptionPlan.id}`
      ).postRequestWithJsonResponse(requestBody);

      console.log("Course enroll Response 2: ", JSON.stringify(response));

      const redirectUrl = response?.data?.redirectUrl;

      console.log("Redirect url ", redirectUrl);

      if (redirectUrl) {
        console.log("Redirecting to:", redirectUrl);
        // Open the redirect URL in a new tab
        const newTab = window.open(redirectUrl, "_blank"); // Open the target URL in a new tab
        if (!newTab) {
          console.error("Popup blocked. Redirecting in the same tab instead.");
          window.location.href = redirectUrl; // Fallback to same-tab redirection
        }
      } else {
        console.error("Redirect URL not found in response.");
      }
    } catch (error) {
      console.error("Error during payment process:", error);
    } finally {
      // setLoading(false); // Stop loader
    }
  };


  useEffect(() => {
    const isLoggedIn = localStorage.getItem(StorageParams.IS_LOGGED_IN) === "true";
    setLoggenIn(isLoggedIn);
    fetchSubscriptionPlans();
  }, []);

  useEffect(() => {
    const fetchGroups = async () => {
      console.log("Fetching groups");
      let searchParameters = { offset: 0, limit: 0 };
      try {
        const response = await new BaseApiService("/organisations/groups").getRequestWithJsonResponse(
          searchParameters
        );
        if (response && response.records) {
          console.log("Reponse ", JSON.stringify(response.records));
          setGroupOptions(response.records);
        } else {
          console.error("Unexpected response structure:", response);
        }
      } catch (error) {
        console.error("CompanyGroup:fetchGroups>>>>", error);
      }
    };

    if (isDialogOpen && purchaseType === "bulk") {
      fetchGroups();
    }
  }, [isDialogOpen, purchaseType]);

  return (
    <>
      <div className="row g-5 mb--60">
        {title !== "" ? (
          <div className="col-lg-6 col-md-6 col-12">
            <div className="section-title text-start">
              <span className="subtitle bg-pink-opacity">{tag}</span>
              <h2 className="title">{title}</h2>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="container">
        <div className="row g-5">
          {plans && plans.map((data, index) => (
            <div className="col-xl-4 col-lg-6 col-md-6 col-12" key={index}>
              <div className={`pricing-table style-2 active`}>
                <div className="pricing-header">
                  <h3
                    className={`title color-primary`}>
                    {data?.name}
                  </h3>
                  <span className="rbt-badge mb--35">
                    {data?.description}
                  </span>
                  <div className="price-wrap">
                    <div className={`yearly-pricing "d-block"`}>
                      <span
                        className={`amount color-primary`}
                      >
                        ${data?.costPerYear}
                      </span>
                      <span
                        className={`duration ms-1 color-primary`}
                      >
                        /Yearly
                      </span>
                    </div>
                  </div>
                </div>
                <div className="pricing-btn">
                  <button
                    onClick={() => {
                      setSubscriptionPlan(data);
                      handleDialogOpen();
                    }}
                    className="rbt-btn bg-primary-opacity hover-icon-reverse w-100"
                    disabled={loading} // Disable button while loading
                  >
                    <span className="icon-reverse-wrapper">
                      <span className="btn-text">
                        {loading ? 'Processing...' : 'Subscribe'}
                      </span>
                      {!loading && (
                        <>
                          <span className="btn-icon">
                            <i className="feather-arrow-right"></i>
                          </span>
                        </>
                      )}
                    </span>
                  </button>
                </div>
                <div className="pricing-body">
                  <ul className="list-item">
                    {data?.commaSeparatedWhatYouGet.split(',').map((item, innerIndex) => (
                      <li key={innerIndex}>
                        <i className={`feather-check`}></i>{" "}
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>


                {/* Dialog rendered here */}
                {isDialogOpen && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 999,
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#fff",
                        padding: "2rem",
                        borderRadius: "8px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                        width: "400px",
                        maxWidth: "90%",
                      }}
                    >
                      <h4 style={{ margin: "0 0 1rem 0", textAlign: "center" }}>
                        Subscription Summary
                      </h4>
                      <p style={{ margin: "0.5rem 0" }}>{subscriptionPlan?.name}</p>
                      <div className="rbt-price">
                        <span className="current-price">${subscriptionPlan?.costPerYear}</span>
                      </div>

                      {/* Radio Buttons */}
                      <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
                        <div
                          style={{
                            flex: 1,
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            padding: "0.75rem",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "0.5rem",
                            backgroundColor: purchaseType === "oneOff" ? "#f0f0f0" : "#fff",
                          }}
                        >
                          <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                            <input
                              type="radio"
                              value="oneOff"
                              checked={purchaseType === "oneOff"}
                              onChange={() => setPurchaseType("oneOff")}
                            />
                            Single Purchase
                          </label>
                        </div>

                        <div
                          style={{
                            flex: 1,
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            padding: "0.75rem",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "0.5rem",
                            backgroundColor: purchaseType === "bulk" ? "#f0f0f0" : "#fff",
                          }}
                        >
                          <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                            <input
                              type="radio"
                              value="bulk"
                              checked={purchaseType === "bulk"}
                              onChange={() => setPurchaseType("bulk")}
                            />
                            Bulk Purchase
                          </label>
                        </div>
                      </div>


                      {/* Dropdown for Bulk Purchase */}
                      {purchaseType === "bulk" && (
                        <div style={{ marginBottom: "1rem" }}>
                          <label htmlFor="groupId">Select Group</label>
                          <select
                            id="groupId"
                            value={selectedGroupId}
                            onChange={(e) => setSelectedGroupId(e.target.value)}
                            style={{
                              width: "100%",
                              padding: "0.5rem",
                              marginTop: "0.5rem",
                              borderRadius: "4px",
                              border: "1px solid #ccc",
                            }}
                          >
                            <option value="">-- Select a Group --</option>
                            {groupOptions.map((group) => (
                              <option key={group.id} value={group.id}>
                                {group.name} ({group.organisation.name})
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      {/* Buttons */}
                      <div style={{ marginTop: "1.5rem", display: "flex", gap: "1rem" }}>
                        <div style={{
                          flex: 1
                        }}></div>

                        <button
                          style={{
                            flex: 1,
                            padding: "0.75rem",
                            backgroundColor: "#f44336",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            textAlign: "center",
                          }}
                          onClick={handleDialogClose}
                        >
                          Cancel
                        </button>
                        <button
                          style={{
                            flex: 1,
                            padding: "0.75rem",
                            backgroundColor: "#4CAF50",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            textAlign: "center",
                          }}
                          onClick={paySubscription}
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                )}



              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default PricingThree;
